import Alert from "../../components/alert";
import { connect } from "react-redux";
import { getDeposit, getSession } from "../../selectors";
import { Link, withRouter } from "react-router-dom";
import React from "react";
import requireAuthentication from "../../components/higher-order/require-authentication";
import Step from "../../components/step";
import Steps from "../../components/steps";

class DepositConfirmationPage extends React.PureComponent {
  constructor(props) {
    super(props);

    var { deposit, history } = props;
    if (!deposit.get("amount") || !deposit.get("confirmed")) {
      history.push("/deposit");
    }
  }

  render() {
    var { deposit } = this.props;
    var authenticationTokenParamPresent = deposit.get("authenticationTokenParamPresent");
    var cta = (
      <p className="margin-top--is-40 margin-bottom--is-40 text-center">
        <Link className="btn btn--large btn--emphasis btn--primary" to="/">
          Browse Tournaments
        </Link>
      </p>
    );

    if (authenticationTokenParamPresent) {
      cta = (
        <p className="margin-top--is-40 margin-bottom--is-40 text-center">
          <Link className="btn btn--primary" to="/">
            Browse All New
            {" "}

            {window.env.brandName}
          </Link>

          <span className="display--is-block-mobile padding-top--is-5 padding-right--is-10 padding-bottom--is-5 padding-left--is-10">
            or
          </span>

          <a className="btn" href="https://www.derbywars.com/">
            Return To Old
            {" "}

            {window.env.brandName}
          </a>
        </p>
      );
    }

    return (
      <div>
        <Alert fixed icon="dw-checkmark3" title="Deposit Pending!" type="notification--caution" />

        <div className="l-wrapper">
          <div className="l-content l-content--80-percent">

            <Steps>
              <Step>
                Deposit Amount
              </Step>

              <Step>
                Billing Information
              </Step>

              <Step>
                Payment Method
              </Step>

              <Step selected>
                Deposit Confirmation
              </Step>
            </Steps>

            <h1 className="text-center">
              Deposit Pending
            </h1>

            <p>
              Thank you for submitting your ACH deposit.
              This will be reviewed by a manager.
              This should take about 10 minutes during DerbyWars hours of 11am to 11pm ET, but may take longer outside of those hours.
              Thank you.
            </p>

            {cta}

          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    deposit: getDeposit(state),
    session: getSession(state)
  };
}

export default connect(select)(requireAuthentication(withRouter(DepositConfirmationPage)));
